export default function HowItWorks() {
  const steps = [
    { step: '01', icon: 'ri-search-eye-line', title: 'Discover', desc: 'Browse organized categories and find product resources that match what you are looking for.' },
    { step: '02', icon: 'ri-file-search-line', title: 'Research', desc: 'Compare product information, check QC photo references, and read shopping guidance notes.' },
    { step: '03', icon: 'ri-check-double-line', title: 'Choose', desc: 'Select the products that best fit your preferences, budget, and quality expectations.' },
    { step: '04', icon: 'ri-external-link-line', title: 'Visit', desc: 'Continue to our main website to complete your shopping journey with confidence.' },
  ];

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
            How It Works
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4 text-balance">
            How Vigorbuy Spreadsheet Works
          </h2>
          <p className="text-foreground-500 text-base max-w-2xl mx-auto">
            A simple four-step process that turns scattered product hunting into an organized and enjoyable shopping experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <div key={s.step} className="relative text-center">
              <div className="w-16 h-16 mx-auto rounded-2xl bg-primary-500 flex items-center justify-center mb-5 relative z-10">
                <i className={`${s.icon} text-white text-2xl`}></i>
              </div>
              <span className="text-xs font-bold text-primary-500 tracking-widest uppercase">{s.step}</span>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mt-1 mb-2">{s.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{s.desc}</p>

              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[calc(50%+40px)] w-[calc(100%-80px)] h-px bg-background-300">
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-primary-400"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}